namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_settings_chart, {
		
		Axis_content: {
			gap: $mol_gap.space,
		},
		
	} )
	
}
